/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import type {
  AreaCreateBody,
  AreaListResponse,
  AreaMembershipListResponse,
  AreaResponse,
  AreaUpdateBody,
  AuthForgotPasswordBody,
  AuthLoginBody,
  AuthResetPasswordBody,
  AvailabilityListResponse,
  BroadcastListResponse,
  BuildingCreateBody,
  BuildingListResponse,
  BuildingMembershipListResponse,
  BuildingResponse,
  BuildingUpdateBody,
  CandidateLeaveRequestResponse,
  DeleteOrgsOrgEmployeeShiftsShiftOffer200,
  DeleteOrgsOrgEmployeeShiftsShiftOfferWithdraw200,
  DeleteOrgsOrgEmployeesEmployeeSkillsBody,
  DepartmentListResponse,
  DepartmentMemberUpdateBody,
  DepartmentResponse,
  DepartmentUpdateBody,
  EffectiveJobRoleListResponse,
  EmployeeListResponse,
  EmployeeOfferListResponse,
  EmployeeResponse,
  EmployeeShiftListResponse,
  EmployeeShiftResponse,
  GetAuthLogin200,
  GetAuthRegisterBody,
  GetAvailabilityParams,
  GetOrgsOrgAreasParams,
  GetOrgsOrgBuildingsParams,
  GetOrgsOrgConfig200,
  GetOrgsOrgEmployeeBroadcastsParams,
  GetOrgsOrgEmployeeBuildingsMembershipsParams,
  GetOrgsOrgEmployeeBuildingsParams,
  GetOrgsOrgEmployeeShiftsParams,
  GetOrgsOrgEmployeeSkillsParams,
  GetOrgsOrgEmployeeTimeOffDatesParams,
  GetOrgsOrgEmployeeTimeOffParams,
  GetOrgsOrgEmployeesEmployeeBuildingsParams,
  GetOrgsOrgEmployeesParams,
  GetOrgsOrgInsightsAcceptance200,
  GetOrgsOrgInsightsEngagementChange200,
  GetOrgsOrgJobRolesParams,
  GetOrgsOrgJobTitlesParams,
  GetOrgsOrgJoinRequests200,
  GetOrgsOrgJoinRequestsParams,
  GetOrgsOrgNotificationsParams,
  GetOrgsOrgOnboardingComplete200,
  GetOrgsOrgShiftBookingConstraintProfilesParams,
  GetOrgsOrgShiftsActivityExportParams,
  GetOrgsOrgShiftsParams,
  GetOrgsOrgShiftsShiftEmployeesParams,
  GetOrgsOrgSkillsParams,
  GetOrgsOrgTimeOffDatesParams,
  GetOrgsOrgTimeOffParams,
  GetOrgsOrgTimeOffReasons200,
  GetOrgsOrgUserPermissions200,
  GetSitesSiteIdUsersParams,
  GetUserPushTokens200,
  GetUserTwoFactorQrCode200,
  GetUserTwoFactorSecretKey200,
  GroupListResponse,
  GroupResponse,
  GroupUserUpdateBody,
  JobRoleCollectionResponse,
  JobRoleCreateBody,
  JobRoleListResponse,
  JobRoleResponse,
  JobRoleUpdateBody,
  JobTitleCreateBody,
  JobTitleJobRolesSyncBody,
  JobTitleListResponse,
  JobTitleResponse,
  JobTitleUpdateBody,
  JoinRequestResponse,
  MemberListResponse,
  NotificationListResponse,
  OnboardingDraft,
  OnboardingDraftSaveBody,
  OrganisationListResponse,
  OrganisationResponse,
  PatchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequestBody,
  PermissionListResponse,
  PlanListResponse,
  PostAvailabilityBulkBody,
  PostOrgsOrgCandidateLeaveRequestsBody,
  PostOrgsOrgEmployeesBody,
  PostOrgsOrgEmployeesEmployeeSkillsBody,
  PostSitesSiteUsersUserMembershipBody,
  PostUserConfirmedTwoFactorAuthenticationBody,
  PutOrgsOrgEmployeeBroadcastsBody,
  PutOrgsOrgEmployeeShiftsShiftOffer200,
  PutOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileBody,
  PutOrgsOrgOnboardingDraft200,
  PutUserPasswordBody,
  PutUserPushTokenBody,
  PutUserPushTokens201,
  PutUserPushTokensBody,
  ShiftBookingConstraintProfileEmployeeResponse,
  ShiftBookingConstraintProfileListResponse,
  ShiftBookingConstraintProfileResponse,
  ShiftBookingConstraintProfileUpdateBody,
  ShiftCreateBody,
  ShiftListResponse,
  ShiftReasonCreateBody,
  ShiftReasonListResponse,
  ShiftReasonResponse,
  ShiftReasonUpdateBody,
  ShiftResponse,
  SkillListResponse,
  SubscriptionResponse,
  TimeOffCreateBody,
  TimeOffDateListResponse,
  TimeOffListResponse,
  TimeOffResponse,
  TimeOffUpdateBody,
  TimesheetCreateBody,
  TimesheetEventCreateBody,
  TimesheetEventResponse,
  TimesheetResponse,
  UserCreateBody,
  UserListResponse,
  UserResponse,
  UserUpdateBody
} from '../models';

import { customInstance } from '../../../../axiosInstance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getCliniShiftManager = () => {
/**
 * List all users for the site specified in the path parameter.
 * @summary User List
 */
const getSitesSiteIdUsers = (
    site: number,
    params?: GetSitesSiteIdUsersParams,
 options?: SecondParameter<typeof customInstance<UserListResponse>>,) => {
      return customInstance<UserListResponse>(
      {url: `/api/sites/${site}/users`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create a user for the site specified in the path parameter.
 * @summary User Create
 */
const postSitesSiteUsers = (
    site: number,
    userCreateBody?: UserCreateBody,
 options?: SecondParameter<typeof customInstance<UserResponse>>,) => {
      return customInstance<UserResponse>(
      {url: `/api/sites/${site}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreateBody
    },
      options);
    }

/**
 * Show full details for a user related to the site defined in the path param.
 * @summary User Show
 */
const getSitesSiteUsersUser = (
    site: number,
    user: number,
 options?: SecondParameter<typeof customInstance<UserResponse>>,) => {
      return customInstance<UserResponse>(
      {url: `/api/sites/${site}/users/${user}`, method: 'GET'
    },
      options);
    }

/**
 * Update full details for a user related to the site defined in the path param.
 * @summary User Update
 */
const patchSitesSiteUsersUser = (
    site: number,
    user: number,
    userUpdateBody?: UserUpdateBody,
 options?: SecondParameter<typeof customInstance<UserResponse>>,) => {
      return customInstance<UserResponse>(
      {url: `/api/sites/${site}/users/${user}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateBody
    },
      options);
    }

/**
 * Membership is the connection between a user and a site. Membership can function differently depending on the user type.
 *
 * Admin/Manager
 *
 * Has:
 * - Departments
 * - Groups
 *
 * Doesn't have:
 * - Occupation
 *
 * Candidate/Staff
 *
 * Has:
 * - Groups
 * - Occupation
 *
 * Doesn't Have:
 * - Departments
 */
const postSitesSiteUsersUserMembership = (
    site: number,
    user: number,
    postSitesSiteUsersUserMembershipBody?: PostSitesSiteUsersUserMembershipBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/users/${user}/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSitesSiteUsersUserMembershipBody
    },
      options);
    }

/**
 * Deleting a membership fully removes access to a site. All access settings will also be deleted, including permissions.
 *
 * Admin/Manager
 *
 * Removes:
 * - Departments
 * - Groups
 *
 * Candidate/Staff
 *
 * Removes:
 * - Groups
 * - Occupation
 */
const deleteSitesSiteUsersUserMembership = (
    site: number,
    user: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/users/${user}/membership`, method: 'DELETE'
    },
      options);
    }

/**
 * List all groups for the organisation specified in the path parameter.
 * @summary List site groups
 */
const getOrgsOrgGroups = (
    org: string,
 options?: SecondParameter<typeof customInstance<GroupListResponse>>,) => {
      return customInstance<GroupListResponse>(
      {url: `/api/orgs/${org}/groups`, method: 'GET'
    },
      options);
    }

/**
 * Create a group for the organisation specified in the path parameter.
 * @summary Create site group
 */
const postOrgsOrgGroups = (
    org: string,
 options?: SecondParameter<typeof customInstance<GroupResponse>>,) => {
      return customInstance<GroupResponse>(
      {url: `/api/orgs/${org}/groups`, method: 'POST'
    },
      options);
    }

/**
 * Get a group for the organisation specified in the path parameter.
 * @summary Get site group
 */
const getOrgsOrgGroupsGroup = (
    org: string,
    group: string,
 options?: SecondParameter<typeof customInstance<GroupResponse>>,) => {
      return customInstance<GroupResponse>(
      {url: `/api/orgs/${org}/groups/${group}`, method: 'GET'
    },
      options);
    }

/**
 * Update a group for the organisation specified in the path parameter.
 * @summary Update site group
 */
const patchOrgsOrgGroupsGroup = (
    org: string,
    group: string,
 options?: SecondParameter<typeof customInstance<GroupResponse>>,) => {
      return customInstance<GroupResponse>(
      {url: `/api/orgs/${org}/groups/${group}`, method: 'PATCH'
    },
      options);
    }

/**
 * Delete a group for the organisation specified in the path parameter.
 * @summary Delete site group
 */
const deleteOrgsOrgGroupsGroup = (
    org: string,
    group: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/groups/${group}`, method: 'DELETE'
    },
      options);
    }

/**
 * List all users for the group specified in the path parameter.
 * @summary List group users
 */
const getSitesSiteGroupsGroupUsers = (
    site: number,
    group: string,
 options?: SecondParameter<typeof customInstance<UserListResponse>>,) => {
      return customInstance<UserListResponse>(
      {url: `/api/sites/${site}/groups/${group}/members`, method: 'GET'
    },
      options);
    }

/**
 * Add users to the group specified in the path parameter.
 * @summary Add users to a group
 */
const postSitesSiteGroupsGroupUsers = (
    site: number,
    group: string,
    groupUserUpdateBody?: GroupUserUpdateBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/groups/${group}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupUserUpdateBody
    },
      options);
    }

/**
 * Remove users from the group specified in the path parameter.
 * @summary Remove users from a group
 */
const deleteSitesSiteGroupsGroupUsers = (
    site: number,
    group: string,
    groupUserUpdateBody?: GroupUserUpdateBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/groups/${group}/members`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: groupUserUpdateBody
    },
      options);
    }

/**
 * List all employees for the site specified in the path parameter.
 * @summary Get Employees
 */
const getSitesSiteEmployees = (
    site: number,
 options?: SecondParameter<typeof customInstance<EmployeeListResponse>>,) => {
      return customInstance<EmployeeListResponse>(
      {url: `/api/sites/${site}/employees`, method: 'GET'
    },
      options);
    }

/**
 * Get an employee for the site specified in the path parameter.
 * @summary Get Employee
 */
const getSitesSiteEmployeesEmployee = (
    site: number,
    employee: string,
 options?: SecondParameter<typeof customInstance<EmployeeResponse>>,) => {
      return customInstance<EmployeeResponse>(
      {url: `/api/sites/${site}/employees/${employee}`, method: 'GET'
    },
      options);
    }

/**
 * List all departments for the site specified in the path parameter.
 * @summary Department List
 */
const getSitesSiteDepartments = (
    site: number,
 options?: SecondParameter<typeof customInstance<DepartmentListResponse>>,) => {
      return customInstance<DepartmentListResponse>(
      {url: `/api/sites/${site}/departments`, method: 'GET'
    },
      options);
    }

/**
 * Create a department for the site specified in the path parameter.
 * @summary Department Create
 */
const postSitesSiteDepartments = (
    site: number,
 options?: SecondParameter<typeof customInstance<DepartmentResponse>>,) => {
      return customInstance<DepartmentResponse>(
      {url: `/api/sites/${site}/departments`, method: 'POST'
    },
      options);
    }

/**
 * Get a department for the site specified in the path parameter.
 * @summary Department Show
 */
const getSitesSiteDepartmentsDepartment = (
    site: number,
    department: string,
 options?: SecondParameter<typeof customInstance<DepartmentResponse>>,) => {
      return customInstance<DepartmentResponse>(
      {url: `/api/sites/${site}/departments/${department}`, method: 'GET'
    },
      options);
    }

/**
 * Update a department for the site specified in the path parameter.
 * @summary Department Update
 */
const patchSitesSiteDepartmentsDepartment = (
    site: number,
    department: string,
    departmentUpdateBody?: DepartmentUpdateBody,
 options?: SecondParameter<typeof customInstance<DepartmentResponse>>,) => {
      return customInstance<DepartmentResponse>(
      {url: `/api/sites/${site}/departments/${department}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: departmentUpdateBody
    },
      options);
    }

/**
 * Delete a department for the site specified in the path parameter.
 * @summary Department Delete
 */
const deleteSitesSiteDepartmentsDepartment = (
    site: number,
    department: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/departments/${department}`, method: 'DELETE'
    },
      options);
    }

/**
 * List all members for the department specified in the path parameter.
 * @summary Department Member List
 */
const getSitesSiteDepartmentsDepartmentMembers = (
    site: number,
    department: string,
 options?: SecondParameter<typeof customInstance<MemberListResponse>>,) => {
      return customInstance<MemberListResponse>(
      {url: `/api/sites/${site}/departments/${department}/members`, method: 'GET'
    },
      options);
    }

/**
 * Add a member to the department specified in the path parameter.
 * @summary Department Member Add
 */
const postSitesSiteDepartmentsDepartmentMembers = (
    site: number,
    department: string,
    departmentMemberUpdateBody?: DepartmentMemberUpdateBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/departments/${department}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: departmentMemberUpdateBody
    },
      options);
    }

/**
 * Remove a member from the department specified in the path parameter.
 * @summary Department Member Remove
 */
const deleteSitesSiteDepartmentsDepartmentMembers = (
    site: number,
    department: string,
    departmentMemberUpdateBody?: DepartmentMemberUpdateBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/sites/${site}/departments/${department}/members`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: departmentMemberUpdateBody
    },
      options);
    }

/**
 * Get the change in acceptance rates for the organisation specified in the path parameter.
 * @summary Insight Classic Acceptance Change
 */
const getOrgsOrgInsightsAcceptance = (
    org: string,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgInsightsAcceptance200>>,) => {
      return customInstance<GetOrgsOrgInsightsAcceptance200>(
      {url: `/api/orgs/${org}/insights/classic/acceptance/change`, method: 'GET'
    },
      options);
    }

/**
 * Get the change in engagement rates for the organisation specified in the path parameter.
 * @summary Insight Classic Engagement Change
 */
const getOrgsOrgInsightsEngagementChange = (
    org: string,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgInsightsEngagementChange200>>,) => {
      return customInstance<GetOrgsOrgInsightsEngagementChange200>(
      {url: `/api/orgs/${org}/insights/classic/engagement/change`, method: 'GET'
    },
      options);
    }

/**
 * List all shift reasons for the organisation specified in the path parameter.
 * @summary Shift Reason List
 */
const getOrgsOrgShiftsReasons = (
    org: string,
 options?: SecondParameter<typeof customInstance<ShiftReasonListResponse>>,) => {
      return customInstance<ShiftReasonListResponse>(
      {url: `/api/orgs/${org}/reasons`, method: 'GET'
    },
      options);
    }

/**
 * Create a shift reason for the organisation specified in the path parameter.
 * @summary Shift Reason Create
 */
const postOrgsOrgShiftsReasons = (
    org: string,
    shiftReasonCreateBody?: ShiftReasonCreateBody,
 options?: SecondParameter<typeof customInstance<ShiftReasonResponse>>,) => {
      return customInstance<ShiftReasonResponse>(
      {url: `/api/orgs/${org}/reasons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftReasonCreateBody
    },
      options);
    }

/**
 * Get a shift reason for the organisation specified in the path parameter.
 * @summary Shift Reason Show
 */
const getOrgsOrgShiftsReasonsReason = (
    org: string,
    reason: string,
 options?: SecondParameter<typeof customInstance<ShiftReasonResponse>>,) => {
      return customInstance<ShiftReasonResponse>(
      {url: `/api/orgs/${org}/reasons/${reason}`, method: 'GET'
    },
      options);
    }

/**
 * Update a shift reason for the organisation specified in the path parameter.
 * @summary Shift Reason Update
 */
const patchOrgsOrgShiftsReasonsReason = (
    org: string,
    reason: string,
    shiftReasonUpdateBody?: ShiftReasonUpdateBody,
 options?: SecondParameter<typeof customInstance<ShiftReasonResponse>>,) => {
      return customInstance<ShiftReasonResponse>(
      {url: `/api/orgs/${org}/reasons/${reason}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: shiftReasonUpdateBody
    },
      options);
    }

/**
 * List the job titles for the organisation specified in the path parameter. Any active employee in the organisation can list them.
 * @summary List Job Titles
 */
const getOrgsOrgJobTitles = (
    org: string,
    params?: GetOrgsOrgJobTitlesParams,
 options?: SecondParameter<typeof customInstance<JobTitleListResponse>>,) => {
      return customInstance<JobTitleListResponse>(
      {url: `/api/orgs/${org}/job-titles`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create a job title. The job title is granted the job role with the same name, which is created if it does not exist. Names are unique per organisation, ignoring case and including archived job titles.
 * @summary Create a Job Title
 */
const postOrgsOrgJobTitles = (
    org: string,
    jobTitleCreateBody?: JobTitleCreateBody,
 options?: SecondParameter<typeof customInstance<JobTitleResponse>>,) => {
      return customInstance<JobTitleResponse>(
      {url: `/api/orgs/${org}/job-titles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobTitleCreateBody
    },
      options);
    }

/**
 * Get a job title, including archived job titles.
 * @summary Get a Job Title
 */
const getOrgsOrgJobTitlesJobTitle = (
    org: string,
    jobTitle: string,
 options?: SecondParameter<typeof customInstance<JobTitleResponse>>,) => {
      return customInstance<JobTitleResponse>(
      {url: `/api/orgs/${org}/job-titles/${jobTitle}`, method: 'GET'
    },
      options);
    }

/**
 * Rename a job title. Its auto-created job role is renamed too while that job role still has the old name and no other job title grants it.
 * @summary Rename a Job Title
 */
const patchOrgsOrgJobTitlesJobTitle = (
    org: string,
    jobTitle: string,
    jobTitleUpdateBody?: JobTitleUpdateBody,
 options?: SecondParameter<typeof customInstance<JobTitleResponse>>,) => {
      return customInstance<JobTitleResponse>(
      {url: `/api/orgs/${org}/job-titles/${jobTitle}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: jobTitleUpdateBody
    },
      options);
    }

/**
 * Archive a job title. Blocked while any employee has the job title. Archived job titles cannot be newly assigned or granted, but existing references keep working.
 * @summary Archive a Job Title
 */
const putOrgsOrgJobTitlesJobTitleArchive = (
    org: string,
    jobTitle: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/job-titles/${jobTitle}/archive`, method: 'PUT'
    },
      options);
    }

/**
 * Restore an archived job title.
 * @summary Restore an Archived Job Title
 */
const deleteOrgsOrgJobTitlesJobTitleArchive = (
    org: string,
    jobTitle: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/job-titles/${jobTitle}/archive`, method: 'DELETE'
    },
      options);
    }

/**
 * List the job roles the job title grants, including archived job roles.
 * @summary List a Job Title's Job Roles
 */
const getOrgsOrgJobTitlesJobTitleJobRoles = (
    org: string,
    jobTitle: string,
 options?: SecondParameter<typeof customInstance<JobRoleCollectionResponse>>,) => {
      return customInstance<JobRoleCollectionResponse>(
      {url: `/api/orgs/${org}/job-titles/${jobTitle}/job-roles`, method: 'GET'
    },
      options);
    }

/**
 * Replace the job roles the job title grants. Job roles must be active and belong to the organisation. Rejected when it would remove the default job role of employees who keep other job roles.
 * @summary Set a Job Title's Job Roles
 */
const putOrgsOrgJobTitlesJobTitleJobRoles = (
    org: string,
    jobTitle: string,
    jobTitleJobRolesSyncBody?: JobTitleJobRolesSyncBody,
 options?: SecondParameter<typeof customInstance<JobRoleCollectionResponse>>,) => {
      return customInstance<JobRoleCollectionResponse>(
      {url: `/api/orgs/${org}/job-titles/${jobTitle}/job-roles`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: jobTitleJobRolesSyncBody
    },
      options);
    }

/**
 * List the job roles for the organisation specified in the path parameter. Any active employee in the organisation can list them.
 * @summary List Job Roles
 */
const getOrgsOrgJobRoles = (
    org: string,
    params?: GetOrgsOrgJobRolesParams,
 options?: SecondParameter<typeof customInstance<JobRoleListResponse>>,) => {
      return customInstance<JobRoleListResponse>(
      {url: `/api/orgs/${org}/job-roles`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create a job role. Names are unique per organisation, ignoring case and including archived job roles.
 * @summary Create a Job Role
 */
const postOrgsOrgJobRoles = (
    org: string,
    jobRoleCreateBody?: JobRoleCreateBody,
 options?: SecondParameter<typeof customInstance<JobRoleResponse>>,) => {
      return customInstance<JobRoleResponse>(
      {url: `/api/orgs/${org}/job-roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobRoleCreateBody
    },
      options);
    }

/**
 * Get a job role, including archived job roles.
 * @summary Get a Job Role
 */
const getOrgsOrgJobRolesJobRole = (
    org: string,
    jobRole: string,
 options?: SecondParameter<typeof customInstance<JobRoleResponse>>,) => {
      return customInstance<JobRoleResponse>(
      {url: `/api/orgs/${org}/job-roles/${jobRole}`, method: 'GET'
    },
      options);
    }

/**
 * Rename a job role. Job titles are never renamed with it.
 * @summary Rename a Job Role
 */
const patchOrgsOrgJobRolesJobRole = (
    org: string,
    jobRole: string,
    jobRoleUpdateBody?: JobRoleUpdateBody,
 options?: SecondParameter<typeof customInstance<JobRoleResponse>>,) => {
      return customInstance<JobRoleResponse>(
      {url: `/api/orgs/${org}/job-roles/${jobRole}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: jobRoleUpdateBody
    },
      options);
    }

/**
 * Archive a job role. Blocked while any active future shift has the job role, or while it is the default job role of employees who have other job roles. Archived job roles cannot be newly assigned or granted, but existing references keep working.
 * @summary Archive a Job Role
 */
const putOrgsOrgJobRolesJobRoleArchive = (
    org: string,
    jobRole: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/job-roles/${jobRole}/archive`, method: 'PUT'
    },
      options);
    }

/**
 * Restore an archived job role.
 * @summary Restore an Archived Job Role
 */
const deleteOrgsOrgJobRolesJobRoleArchive = (
    org: string,
    jobRole: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/job-roles/${jobRole}/archive`, method: 'DELETE'
    },
      options);
    }

/**
 * Employees of the organisation, filtered and paginated. CHG-29: `job_role_id` limits the list to employees whose effective job roles include that job role (job-title grants + manual grants, non-archived job roles); the job role must belong to this organisation and not be archived, otherwise 422. The table's job role column shows the default job role, so a matching row can show another role.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.view` (from `manager` role)
 * > If the authenticated user does not have this permission for the organisation defined in the path you will receive a `403` error.
 * @summary List employees of an organisation
 */
const getOrgsOrgEmployees = (
    org: string,
    params?: GetOrgsOrgEmployeesParams,
 options?: SecondParameter<typeof customInstance<EmployeeListResponse>>,) => {
      return customInstance<EmployeeListResponse>(
      {url: `/api/orgs/${org}/employees`, method: 'GET',
        params
    },
      options);
    }

/**
 * Adds a person to the organisation (an existing account gets an employee here; otherwise an account is created and emailed). CHG-13: `job_role_ids` is required with at least one job role when `role` is `staff` (also in an organisation with no job roles: create one first), optional for `manager`. The first job role becomes the default. Skills stay accepted but optional.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.create` (from `manager` role)
 * > If the authenticated user does not have this permission for the organisation defined in the path you will receive a `403` error.
 * @summary Create an employee
 */
const postOrgsOrgEmployees = (
    org: string,
    postOrgsOrgEmployeesBody?: PostOrgsOrgEmployeesBody,
 options?: SecondParameter<typeof customInstance<EmployeeResponse>>,) => {
      return customInstance<EmployeeResponse>(
      {url: `/api/orgs/${org}/employees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postOrgsOrgEmployeesBody
    },
      options);
    }

/**
 * List the job roles granted by the employee's job title plus their manual grants, excluding archived job roles. Each job role lists the sources that grant it.
 * @summary List an Employee's Effective Job Roles
 */
const getOrgsOrgEmployeesEmployeeEffectiveJobRoles = (
    org: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<EffectiveJobRoleListResponse>>,) => {
      return customInstance<EffectiveJobRoleListResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/effective-job-roles`, method: 'GET'
    },
      options);
    }

/**
 * Grant a job role directly to the employee, on top of the job roles their job title grants. It becomes their default job role if they have none. Responds with the employee's effective job roles.
 * @summary Grant a Job Role to an Employee
 */
const putOrgsOrgEmployeesEmployeeJobRoleGrantsJobRole = (
    org: string,
    employee: string,
    jobRole: string,
 options?: SecondParameter<typeof customInstance<EffectiveJobRoleListResponse>>,) => {
      return customInstance<EffectiveJobRoleListResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/job-role-grants/${jobRole}`, method: 'PUT'
    },
      options);
    }

/**
 * Remove a manual job role grant. Job roles granted by the employee's job title are unaffected. Rejected when it would remove the employee's default job role while they have other job roles; change their default first. Responds with the employee's effective job roles.
 * @summary Remove a Job Role Grant from an Employee
 */
const deleteOrgsOrgEmployeesEmployeeJobRoleGrantsJobRole = (
    org: string,
    employee: string,
    jobRole: string,
 options?: SecondParameter<typeof customInstance<EffectiveJobRoleListResponse>>,) => {
      return customInstance<EffectiveJobRoleListResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/job-role-grants/${jobRole}`, method: 'DELETE'
    },
      options);
    }

/**
 * List all organisations.
 * @summary List Organisations
 */
const getOrgs = (

 options?: SecondParameter<typeof customInstance<OrganisationListResponse>>,) => {
      return customInstance<OrganisationListResponse>(
      {url: `/api/orgs`, method: 'GET'
    },
      options);
    }

/**
 * Get an organisation specified in the path parameter.
 * @summary Get an Organisation
 */
const getOrgsOrg = (
    org: string,
 options?: SecondParameter<typeof customInstance<OrganisationResponse>>,) => {
      return customInstance<OrganisationResponse>(
      {url: `/api/orgs/${org}`, method: 'GET'
    },
      options);
    }

/**
 * List all buildings for the organisation specified in the path parameter.
 * @summary List Buildings
 */
const getOrgsOrgBuildings = (
    org: string,
    params?: GetOrgsOrgBuildingsParams,
 options?: SecondParameter<typeof customInstance<BuildingListResponse>>,) => {
      return customInstance<BuildingListResponse>(
      {url: `/api/orgs/${org}/buildings`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create a building for the organisation specified in the path parameter.
 * @summary Create a Building
 */
const postOrgsOrgBuildings = (
    org: string,
    buildingCreateBody?: BuildingCreateBody,
 options?: SecondParameter<typeof customInstance<BuildingResponse>>,) => {
      return customInstance<BuildingResponse>(
      {url: `/api/orgs/${org}/buildings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: buildingCreateBody
    },
      options);
    }

/**
 * Get a building for the organisation specified in the path parameter.
 * @summary Get a Building
 */
const getOrgsOrgBuildingsBuilding = (
    org: string,
    building: string,
 options?: SecondParameter<typeof customInstance<BuildingResponse>>,) => {
      return customInstance<BuildingResponse>(
      {url: `/api/orgs/${org}/buildings/${building}`, method: 'GET'
    },
      options);
    }

/**
 * Update a building for the organisation specified in the path parameter.
 * @summary Update a Building
 */
const patchOrgsOrgBuildingsBuilding = (
    org: string,
    building: string,
    buildingUpdateBody?: BuildingUpdateBody,
 options?: SecondParameter<typeof customInstance<BuildingResponse>>,) => {
      return customInstance<BuildingResponse>(
      {url: `/api/orgs/${org}/buildings/${building}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: buildingUpdateBody
    },
      options);
    }

/**
 * Delete a building for the organisation specified in the path parameter.
 * @summary Delete a Building
 */
const deleteOrgsOrgBuildingsBuilding = (
    org: string,
    building: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/buildings/${building}`, method: 'DELETE'
    },
      options);
    }

/**
 * Archive a building for the organisation specified in the path parameter.
 * @summary Archive a Building
 */
const putOrgsOrgBuildingsBuildingArchive = (
    org: string,
    building: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/buildings/${building}/archive`, method: 'PUT'
    },
      options);
    }

/**
 * Restore an archived building for the organisation specified in the path parameter.
 * @summary Restore an Archived Building
 */
const deleteOrgsOrgBuildingsBuildingArchive = (
    org: string,
    building: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/buildings/${building}/archive`, method: 'DELETE'
    },
      options);
    }

/**
 * List all areas for the building specified in the path parameter.
 * @summary List Areas for a Building
 */
const getSitesSiteBuildingsBuildingAreas = (
    org: string,
    building: string,
 options?: SecondParameter<typeof customInstance<AreaListResponse>>,) => {
      return customInstance<AreaListResponse>(
      {url: `/api/orgs/${org}/buildings/${building}/areas`, method: 'GET'
    },
      options);
    }

/**
 * Create an area for the building specified in the path parameter.
 * @summary Create an Area in a Building
 */
const postSitesSiteBuildingsBuildingAreas = (
    org: string,
    building: string,
    areaCreateBody?: AreaCreateBody,
 options?: SecondParameter<typeof customInstance<AreaResponse>>,) => {
      return customInstance<AreaResponse>(
      {url: `/api/orgs/${org}/buildings/${building}/areas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: areaCreateBody
    },
      options);
    }

/**
 * List all areas for the organisation specified in the path parameter.
 * @summary List Areas
 */
const getOrgsOrgAreas = (
    org: string,
    params?: GetOrgsOrgAreasParams,
 options?: SecondParameter<typeof customInstance<AreaListResponse>>,) => {
      return customInstance<AreaListResponse>(
      {url: `/api/orgs/${org}/areas`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create an area for the organisation specified in the path parameter.
 * @summary Create an Area
 */
const postOrgsOrgAreas = (
    org: string,
    areaCreateBody?: AreaCreateBody,
 options?: SecondParameter<typeof customInstance<AreaResponse>>,) => {
      return customInstance<AreaResponse>(
      {url: `/api/orgs/${org}/areas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: areaCreateBody
    },
      options);
    }

/**
 * Get an area for the organisation specified in the path parameter.
 * @summary Get an Area
 */
const getOrgsOrgAreasArea = (
    org: string,
    area: string,
 options?: SecondParameter<typeof customInstance<AreaResponse>>,) => {
      return customInstance<AreaResponse>(
      {url: `/api/orgs/${org}/areas/${area}`, method: 'GET'
    },
      options);
    }

/**
 * Update an area for the organisation specified in the path parameter.
 * @summary Update an Area
 */
const patchOrgsOrgAreasArea = (
    org: string,
    area: string,
    areaUpdateBody?: AreaUpdateBody,
 options?: SecondParameter<typeof customInstance<AreaResponse>>,) => {
      return customInstance<AreaResponse>(
      {url: `/api/orgs/${org}/areas/${area}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: areaUpdateBody
    },
      options);
    }

/**
 * Delete an area for the organisation specified in the path parameter.
 * @summary Delete an Area
 */
const deleteOrgsOrgAreasArea = (
    org: string,
    area: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/areas/${area}`, method: 'DELETE'
    },
      options);
    }

/**
 * Archive an area for the organisation specified in the path parameter.
 * @summary Archive an Area
 */
const putOrgsOrgAreasAreaLock = (
    org: string,
    area: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/areas/${area}/archive`, method: 'PUT'
    },
      options);
    }

/**
 * Restore an archived area for the organisation specified in the path parameter.
 * @summary Restore an Archived Area
 */
const deleteOrgsOrgAreasAreaLock = (
    org: string,
    area: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/areas/${area}/archive`, method: 'DELETE'
    },
      options);
    }

/**
 * List shifts for an Organisation that you have permission to view.
 *
 * > This endpoint does not return Shifts that you are eligible to work. This endpoint is intended for shift management within an Organisation.
 * >
 * > There will be an endpoint to retrieve Shifts you are eligible to work and respond to.
 * @summary List Shifts for an Organisation
 */
const getOrgsOrgShifts = (
    org: string,
    params?: GetOrgsOrgShiftsParams,
 options?: SecondParameter<typeof customInstance<ShiftListResponse>>,) => {
      return customInstance<ShiftListResponse>(
      {url: `/api/orgs/${org}/shifts`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create a shift for the site specified in the path parameter.
 * @summary Create a shift in an Organisation
 */
const postOrgsOrgShifts = (
    org: string,
    shiftCreateBody?: ShiftCreateBody,
 options?: SecondParameter<typeof customInstance<ShiftResponse>>,) => {
      return customInstance<ShiftResponse>(
      {url: `/api/orgs/${org}/shifts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftCreateBody
    },
      options);
    }

/**
 * The Activity page's booked shifts and each employee's totals as an Excel workbook (xlsx) download, for the same filters as the page.
 *
 * The shifts are the accepted offers on the organisation's published, active shifts that start on the chosen days, for the employees the page lists (current staff, matching `name`). The `Shifts` worksheet has one row per booked shift: `Employee ID`, `Employee Name`, `Shift ID`, `Start Date`, `End Date`, `Booked Hours`, `Worked Hours`, `Checked In At`, `Checked Out At`, `Rate`, `Reason Name`, `Area Name`, `Job Role`. The `Employees` worksheet has one row per employee in it: `Employee ID`, `Employee Name`, `Booked Hours`, `Worked Hours`, `Shift Count` (their booked shifts in the export).
 *
 * Times are in each shift's timezone. Booked hours are the shift's length; worked hours are from check-in to check-out, blank until the employee has both (0 in the totals). `Rate` is per hour in major units. Hours are rounded to 2 decimals per shift and the totals add up the rounded values.
 *
 * <!-- theme: warning -->
 * > #### Feature Flag: `legacy_shift_activity_export`
 * > Set in the organisation's settings (`settings.legacy_shift_activity_export`, `feature_flags.legacy-shift-activity-export` in `GET /orgs/{org}/config`), off by default. If it is off you will receive a `403` error with `feature: legacy_shift_activity_export`.
 * @summary Export the Activity page
 */
const getOrgsOrgShiftsActivityExport = (
    org: string,
    params: GetOrgsOrgShiftsActivityExportParams,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/orgs/${org}/shifts/activity/export`, method: 'GET',
        params,
        responseType: 'blob'
    },
      options);
    }

/**
 * This endpoint will return Employees that can view and respond to the Shift.
 *
 * The `Employee` objects will contain another field called `Offer`. The `Offer` contains details about the Employee's response to the Shift.
 * @summary List eligible Employees for a Shift
 */
const getOrgsOrgShiftsShiftEmployees = (
    org: string,
    shift: string,
    params?: GetOrgsOrgShiftsShiftEmployeesParams,
 options?: SecondParameter<typeof customInstance<EmployeeOfferListResponse>>,) => {
      return customInstance<EmployeeOfferListResponse>(
      {url: `/api/orgs/${org}/shifts/${shift}/employees`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create a shift for the site specified in the path parameter.
 * @summary Create a site shift
 */
const postOrgsOrgShiftsShiftEmployees = (
    org: string,
    shift: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/shifts/${shift}/employees`, method: 'POST'
    },
      options);
    }

/**
 * Authenticate a user and return a session token.
 * @summary Login
 */
const getAuthLogin = (
    authLoginBody?: AuthLoginBody,
 options?: SecondParameter<typeof customInstance<GetAuthLogin200>>,) => {
      return customInstance<GetAuthLogin200>(
      {url: `/api/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authLoginBody
    },
      options);
    }

/**
 * Register a new user.
 * @summary Register
 */
const getAuthRegister = (
    getAuthRegisterBody?: GetAuthRegisterBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getAuthRegisterBody
    },
      options);
    }

/**
 * Send a password reset email.
 * @summary Forgot Password by Code
 */
const postAuthForgotPasswordCode = (
    authForgotPasswordBody?: AuthForgotPasswordBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/auth/forgot-password-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authForgotPasswordBody
    },
      options);
    }

/**
 * Reset a user's password.
 * @summary Reset Password by Code
 */
const postAuthResetPasswordCode = (
    authResetPasswordBody?: AuthResetPasswordBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/auth/reset-password-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authResetPasswordBody
    },
      options);
    }

/**
 * Vonage inbound message webhook
 */
const postVonageMessagesInbound = (

 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/vonage-messages/inbound`, method: 'POST'
    },
      options);
    }

/**
 * Vonage message status webhook
 */
const postVonageMessagesStatus = (

 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/vonage-messages/status`, method: 'POST'
    },
      options);
    }

/**
 * List all skills for the employee specified in the path parameter.
 * @summary List Skills for an Employee
 */
const getOrgsOrgEmployeesEmployeeSkills = (
    org: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<SkillListResponse>>,) => {
      return customInstance<SkillListResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/skills`, method: 'GET'
    },
      options);
    }

/**
 * Add skills to the employee specified in the path parameter.
 * @summary Add Skills to an Employee
 */
const postOrgsOrgEmployeesEmployeeSkills = (
    org: string,
    employee: string,
    postOrgsOrgEmployeesEmployeeSkillsBody?: PostOrgsOrgEmployeesEmployeeSkillsBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/employees/${employee}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postOrgsOrgEmployeesEmployeeSkillsBody
    },
      options);
    }

/**
 * Remove skills from the employee specified in the path parameter.
 * @summary Remove Skills from an Employee
 */
const deleteOrgsOrgEmployeesEmployeeSkills = (
    org: string,
    employee: string,
    deleteOrgsOrgEmployeesEmployeeSkillsBody?: DeleteOrgsOrgEmployeesEmployeeSkillsBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/employees/${employee}/skills`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteOrgsOrgEmployeesEmployeeSkillsBody
    },
      options);
    }

/**
 * Allow an employee access to the building specified in the path parameter.
 * @summary Allow an Employee Access to a Building
 */
const putOrgsOrgBuildingsBuildingMembershipsEmployee = (
    org: string,
    building: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/buildings/${building}/memberships/${employee}`, method: 'PUT'
    },
      options);
    }

/**
 * Block an employee from the building specified in the path parameter.
 * @summary Block an Employee from a Building
 */
const deleteOrgsOrgBuildingsBuildingMembershipsEmployee = (
    org: string,
    building: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/buildings/${building}/memberships/${employee}`, method: 'DELETE'
    },
      options);
    }

/**
 * List all buildings the employee specified in the path parameter has access to.
 * @summary List Building Access for an Employee
 */
const getOrgsOrgEmployeesEmployeeBuildings = (
    org: string,
    employee: string,
    params?: GetOrgsOrgEmployeesEmployeeBuildingsParams,
 options?: SecondParameter<typeof customInstance<BuildingMembershipListResponse>>,) => {
      return customInstance<BuildingMembershipListResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/buildings`, method: 'GET',
        params
    },
      options);
    }

/**
 * List all areas the employee specified in the path parameter has access to.
 * @summary List Area Access for an Employee
 */
const getOrgsOrgEmployeesEmployeeAreas = (
    org: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<AreaMembershipListResponse>>,) => {
      return customInstance<AreaMembershipListResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/areas`, method: 'GET'
    },
      options);
    }

/**
 * Allow an employee access to the area specified in the path parameter.
 * @summary Allow Area Access for an Employee
 */
const putOrgsOrgAreasAreaMembershipsEmployee = (
    org: string,
    area: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/areas/${area}/memberships/${employee}`, method: 'PUT'
    },
      options);
    }

/**
 * Block an employee from the area specified in the path parameter.
 * @summary Block Area Access for an Employee
 */
const deleteOrgsOrgAreasAreaMembershipsEmployee = (
    org: string,
    area: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/areas/${area}/memberships/${employee}`, method: 'DELETE'
    },
      options);
    }

/**
 * List the authenticated user's in-app notifications for the organisation specified in the path parameter.
 *
 * Results are ordered by `occurred_at` in descending order, meaning the latest notifications are first. Defaults to unread notifications only.
 * @summary List Notifications
 */
const getOrgsOrgNotifications = (
    org: string,
    params?: GetOrgsOrgNotificationsParams,
 options?: SecondParameter<typeof customInstance<NotificationListResponse>>,) => {
      return customInstance<NotificationListResponse>(
      {url: `/api/orgs/${org}/notifications`, method: 'GET',
        params
    },
      options);
    }

/**
 * Mark all notifications as read for the organisation specified in the path parameter.
 * @summary Mark All Notifications Read
 */
const putOrgsOrgNotifications = (
    org: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/notifications`, method: 'PUT'
    },
      options);
    }

/**
 * Mark a notification as read for the organisation specified in the path parameter.
 * @summary Mark Notification Read
 */
const putOrgsOrgNotificationsNotification = (
    org: string,
    notification: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/notifications/${notification}`, method: 'PUT'
    },
      options);
    }

/**
 * > #### Missing Results
 * >
 * > Shifts can disappear from results if certain changes are made to the shift or the authenticated employee.
 * >
 * > The following can cause shifts to no longer appear in the results (Not all scenarios are listed here. Eligibility rules still apply.):
 * >
 * > - The shift is `cancelled`
 * > - The shift is `unpublished`
 * > - The shift was deleted
 * > - The employee has lost building access
 * > - The employee has lost area access
 * > - The employee has lost some or all required skills (Archived skills are ignored)
 *
 * > Eligible
 * >
 * > `Eligible` means that the user meets all requirements to see the `Shift` as a potential person to book the shift.
 * >
 * > [@See Shifts](https://github.com/Clinishift/Wiki/wiki/Shifts) for details on eligibility checks.
 * >
 * > A `Shift` may be returned by this endpoint but not be present in the results from `/orgs/{org}/shifts`, and vice versa. This is because the `/orgs/{org}/shifts` endpoint is for shift management, not booking. And having the correct permissions to manage a shift does not mean you are eligible to work it. Likewise, having the permission to work a shift does not mean you have the permissions to manage it.
 *
 * > Why is there no single endpoint that returns all shifts I am eligible to work?
 * >
 * > *ADVANCED - This is an advanced concept and is not required understand to use this API effectively. It is added as a reference only.*
 * >
 * > CliniShift is based on a "Tenant" system with the Tenant currently being identified by the path param - `{org}`. A single endpoint to return all shifts would be required to cross Tenant boundaries. It would be possible to implement this but there are other considerations.
 * >
 * > `Vendor Shifts`
 * > A Vendor Shift is a concept in CliniShift where the `Shift` is created by an `Organisation` but needs to be filled by Employees from another `Organisation` (the Vendor). Employees can belong to both the Organisation that created the shift and the Vendor. However, there can be rules in place that cause an Employee to not be eligible to work more shifts in the Organisation that created the shift but they are eligible to book the shift through the Vendor.
 * > There can also be pay differences between shifts taken through an Organisation compared to a Vendor.
 * >
 * > Because a single Shift can be booked in two different ways, through the Organisation that created it or through the Vendor, we need a way to identify which "context" a user is attempting to book the shift in. As an Employee of the Organisation or the Vendor. If we had a single endpoint for all shifts, the same shift could be present in the results more than once. Each result would then need to have it's own endpoint for responding to a shift.
 * >
 * > `GET` `/user/shifts`- Get all shifts regardless of Organisation
 * >
 * > `POST` `/orgs/{created_org}/user/shifts/{shift}` - Respond to the shift as an Employee of the Organisation that created the shift
 * >
 * > `POST` `/orgs/{vendor_org}/user/shifts/{shift}` - Respond to the shift as an Employee of the Vendor
 * >
 * > This is not straight forward. For this reason, a central shifts endpoint cannot be implemented cleanly.
 * >
 * > The approach we have taken is that there must be an Organisation defined when listing eligible shifts.
 * >
 * > `GET` `/orgs/{org}/user/shifts` - Get all shifts for this Organisation
 * >
 * > `POST` `/orgs/{org}/users/shifts/{shift}` - Respond to the shift
 * >
 * > This allows consumers, especially the mobile app, avoid handling the concept of responding to a shift from different contexts.
 *
 * > Search for shifts on a single date
 * >
 * > In the mobile UI, shifts will often be presented to the user based on a single day at a time. A search for all shifts on a single day can be done by sending the `start_after` and `start_before` params covering the 24 hour period required. This search is done using 2 params instead of a single "date" param because the `date` for a shift can be different depending on the timezone so we need to know the specific 24 hour period the user cares about.
 * >
 * > A user in the UTC timezone that wants all shifts on the 21st Oct can send the params `start_after=2024-10-21T00:00:00Z` and `start_before=2024-10-21T23:59:59Z`.
 * > A user in the UTC+1 timezone must adjust the params so that they cover the intended timezone. This user search would send params as `start_after=2024-10-21T01:00:00Z` and `start_before=2024-10-22T00:59:59Z`. Note that the `start_before` param refers to the 22nd rather than the 21st.
 *
 * > `Includes`
 * >
 * > You will likely need more information regarding nested objects than is provided by default by this endpoint. You can request more information by using the `includes` query param which takes an array of values you want more information on.
 * >
 * > By default, `roster_offer` and `employee_offer` are the only nested objected returned. You will likely want to request the `employee` object for the `roster_offer` so that if you have permission to view that employee, you can display their avatar and/or name.
 * >
 * > Another example is `area` and `building`. The `area` is the location of the shift, each `area` is located within a `building`. You will likely want to display both the `area` and `building` names to the user.
 * >
 * > Finally, there is `skills`. `Skills` are the required items to work the shift. A shift can have more than 1 skill at a time. The `Skills` likely indicate the type of work that will be performed on the shift as well.
 * >
 * > To request all the above examples in the response items you can pass an includes value that looks like this:
 * >
 * > ```
 * > [
 * >  'roster_offer.employee', // Include the employee within the roster offer item
 * >  'area.building', // Include the area, and also the building within the area item
 * >  'skills', // Include all skills for the shift
 * > ]
 * > ```
 * >
 * > Resulting in a URL that looks like `api/orgs/1/employee/shifts?includes[0]=roster_offer.employee&includes[1]=area.building&includes[2]=skills`
 * @summary List Shifts the authenticated Employee is eligible to work
 */
const getOrgsOrgEmployeeShifts = (
    org: string,
    params?: GetOrgsOrgEmployeeShiftsParams,
 options?: SecondParameter<typeof customInstance<EmployeeShiftListResponse>>,) => {
      return customInstance<EmployeeShiftListResponse>(
      {url: `/api/orgs/${org}/employee/shifts`, method: 'GET',
        params
    },
      options);
    }

/**
 * Get a Shift for the authenticated Employee
 * @summary Get a Shift for the authenticated Employee
 */
const getOrgsOrgEmployeeShiftsShift = (
    org: string,
    shift: string,
 options?: SecondParameter<typeof customInstance<EmployeeShiftResponse>>,) => {
      return customInstance<EmployeeShiftResponse>(
      {url: `/api/orgs/${org}/employee/shifts/${shift}`, method: 'GET'
    },
      options);
    }

/**
 * Respond to a Shift for the authenticated user
 * @summary Respond to a Shift for the authenticated user
 */
const postOrgsOrgUserShiftsShift = (
    org: string,
    shift: string,
 options?: SecondParameter<typeof customInstance<ShiftResponse>>,) => {
      return customInstance<ShiftResponse>(
      {url: `/api/orgs/${org}/employee/shifts/${shift}`, method: 'POST'
    },
      options);
    }

/**
 * Attempt to claim a shift within an Organisation for the authenticated employee
 * @summary Attempt to claim a shift within an Organisation for the authenticated employee
 */
const putOrgsOrgEmployeeShiftsShiftOffer = (
    org: string,
    shift: string,
 options?: SecondParameter<typeof customInstance<PutOrgsOrgEmployeeShiftsShiftOffer200>>,) => {
      return customInstance<PutOrgsOrgEmployeeShiftsShiftOffer200>(
      {url: `/api/orgs/${org}/employee/shifts/${shift}/offer`, method: 'PUT'
    },
      options);
    }

/**
 * Decline a shift within an Organisation for the authenticated employee
 * @summary Decline a shift within an Organisation for the authenticated employee
 */
const deleteOrgsOrgEmployeeShiftsShiftOffer = (
    org: string,
    shift: string,
 options?: SecondParameter<typeof customInstance<DeleteOrgsOrgEmployeeShiftsShiftOffer200>>,) => {
      return customInstance<DeleteOrgsOrgEmployeeShiftsShiftOffer200>(
      {url: `/api/orgs/${org}/employee/shifts/${shift}/offer`, method: 'DELETE'
    },
      options);
    }

/**
 * Withdraw an application from a shift within an Organisation for the authenticated employee
 * @summary Withdraw an application from a shift within an Organisation for the authenticated employee
 */
const deleteOrgsOrgEmployeeShiftsShiftOfferWithdraw = (
    org: string,
    shift: string,
 options?: SecondParameter<typeof customInstance<DeleteOrgsOrgEmployeeShiftsShiftOfferWithdraw200>>,) => {
      return customInstance<DeleteOrgsOrgEmployeeShiftsShiftOfferWithdraw200>(
      {url: `/api/orgs/${org}/employee/shifts/${shift}/offer/withdraw`, method: 'DELETE'
    },
      options);
    }

/**
 * List all buildings the authenticated employee is eligible to work in.
 * @summary List Buildings the authenticated Employee is eligible to work in
 */
const getOrgsOrgEmployeeBuildingsMemberships = (
    org: string,
    params?: GetOrgsOrgEmployeeBuildingsMembershipsParams,
 options?: SecondParameter<typeof customInstance<BuildingMembershipListResponse>>,) => {
      return customInstance<BuildingMembershipListResponse>(
      {url: `/api/orgs/${org}/employee/buildings/memberships`, method: 'GET',
        params
    },
      options);
    }

/**
 * List all permissions the authenticated employee has in this organisation.
 * @summary List Permissions the authenticated employee has in this organisation
 */
const getOrgsOrgEmployeePermissions = (
    org: string,
 options?: SecondParameter<typeof customInstance<PermissionListResponse>>,) => {
      return customInstance<PermissionListResponse>(
      {url: `/api/orgs/${org}/employee/permissions`, method: 'GET'
    },
      options);
    }

/**
 * List all skills in an organisation for the authenticated employee.
 * @summary List skills in an organisation for the authenticated employee
 */
const getOrgsOrgEmployeeSkills = (
    org: string,
    params?: GetOrgsOrgEmployeeSkillsParams,
 options?: SecondParameter<typeof customInstance<SkillListResponse>>,) => {
      return customInstance<SkillListResponse>(
      {url: `/api/orgs/${org}/employee/skills`, method: 'GET',
        params
    },
      options);
    }

/**
 * List all buildings in an organisation for the authenticated employee.
 * @summary List buildings in an organisation for the authenticated employee
 */
const getOrgsOrgEmployeeBuildings = (
    org: string,
    params?: GetOrgsOrgEmployeeBuildingsParams,
 options?: SecondParameter<typeof customInstance<BuildingListResponse>>,) => {
      return customInstance<BuildingListResponse>(
      {url: `/api/orgs/${org}/employee/buildings`, method: 'GET',
        params
    },
      options);
    }

/**
 * > Roster
 * >
 * > The `Roster` refers to any shifts booked by other Employee's that you have permission to view. Whether you can view a `Roster` is determined at the `Building` level.
 *
 * [Shift Roster Visibility](clinishift_manager.yaml/components/schemas/ShiftRosterVisibility)
 * @summary List Shifts the authenticated Employee is eligible to see
 */
const getOrgsOrgEmployeeShiftsRoster = (
    org: string,
 options?: SecondParameter<typeof customInstance<EmployeeShiftListResponse>>,) => {
      return customInstance<EmployeeShiftListResponse>(
      {url: `/api/orgs/${org}/employee/shifts/roster`, method: 'GET'
    },
      options);
    }

/**
 * <!-- theme: info -->
 * > #### How is a User different to an Employee?
 * >
 * > A `User` is an "account" within CliniShift. It represents global information for an account.
 * >
 * > An `Employee` is a profile for a specific `Organisation`. A user can be a member of multiple organisations,
 * > and that membership is represented by the `Employee` object.
 * @summary Get the authenticated user
 */
const getUser = (

 options?: SecondParameter<typeof customInstance<UserResponse>>,) => {
      return customInstance<UserResponse>(
      {url: `/api/user`, method: 'GET'
    },
      options);
    }

/**
 * Get the authenticated user's employee for the organisation
 * @summary Get the authenticated user's employee for the organisation
 */
const getOrgsOrgEmployee = (
    org: string,
 options?: SecondParameter<typeof customInstance<EmployeeResponse>>,) => {
      return customInstance<EmployeeResponse>(
      {url: `/api/orgs/${org}/employee`, method: 'GET'
    },
      options);
    }

/**
 * List availability for the authenticated user
 * @summary List availability for the authenticated user
 */
const getAvailability = (
    params?: GetAvailabilityParams,
 options?: SecondParameter<typeof customInstance<AvailabilityListResponse>>,) => {
      return customInstance<AvailabilityListResponse>(
      {url: `/api/availability`, method: 'GET',
        params
    },
      options);
    }

/**
 * Bulk create availability in a single request
 * @summary Bulk create availability in a single request
 */
const postAvailabilityBulk = (
    postAvailabilityBulkBody?: PostAvailabilityBulkBody,
 options?: SecondParameter<typeof customInstance<AvailabilityListResponse>>,) => {
      return customInstance<AvailabilityListResponse>(
      {url: `/api/availability/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAvailabilityBulkBody
    },
      options);
    }

/**
 * Delete an availability
 * @summary Delete an availability
 */
const deleteAvailabilityAvailability = (
    availability: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/availability/${availability}`, method: 'DELETE'
    },
      options);
    }

/**
 * List broadcasts for the authenticated employee in an org
 * @summary List broadcasts for the authenticated employee in an org
 */
const getOrgsOrgEmployeeBroadcasts = (
    org: string,
    params?: GetOrgsOrgEmployeeBroadcastsParams,
 options?: SecondParameter<typeof customInstance<BroadcastListResponse>>,) => {
      return customInstance<BroadcastListResponse>(
      {url: `/api/orgs/${org}/employee/broadcasts`, method: 'GET',
        params
    },
      options);
    }

/**
 * <!-- theme: info -->
 * > #### Seen
 * >
 * >
 * @summary Mark broadcasts as seen
 */
const putOrgsOrgEmployeeBroadcasts = (
    org: string,
    putOrgsOrgEmployeeBroadcastsBody?: PutOrgsOrgEmployeeBroadcastsBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/employee/broadcasts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOrgsOrgEmployeeBroadcastsBody
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > Marking a broadcast as read is only applicable to broadcasts with the `require_approval` flag set to `true`.
 * @summary Mark a broadcast as read
 */
const patchOrgsOrgEmployeeBroadcastsBroadcast = (
    org: string,
    broadcast: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/employee/broadcasts/${broadcast}`, method: 'PATCH'
    },
      options);
    }

/**
 * Add a skill to an employee
 * @summary Add a skill to an employee
 */
const putOrgsOrgSkillsSkillEmployeesEmployee = (
    org: string,
    skill: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/skills/${skill}/employees/${employee}`, method: 'PUT'
    },
      options);
    }

/**
 * Remove a skill from an employee
 * @summary Remove a skill from an employee
 */
const deleteOrgsOrgSkillsSkillEmployeesEmployee = (
    org: string,
    skill: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/skills/${skill}/employees/${employee}`, method: 'DELETE'
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 *
 * > #### Sorting
 * > Currently this request is sorted by the dates and only the direction can be changed. By default it is sorted in ascending order.
 * >
 * > Each `Time Off` request can have multiple dates so they are sorted based on the highest/lowest value out of all dates for a request.
 * > A request with `2025-01-01` and `2025-01-10` will always come before a request with `2025-01-05` and `2025-01-06` because it has both the lowest (`2025-01-01`) and the highest (`2025-01-10`) values.
 * @summary List time off requests for the authenticated employee in an org
 */
const getOrgsOrgEmployeeTimeOff = (
    org: string,
    params?: GetOrgsOrgEmployeeTimeOffParams,
 options?: SecondParameter<typeof customInstance<TimeOffListResponse>>,) => {
      return customInstance<TimeOffListResponse>(
      {url: `/api/orgs/${org}/employee/time-off`, method: 'GET',
        params
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 * @summary Create a time off request for the authenticated employee in an org
 */
const postOrgsOrgEmployeeTimeOff = (
    org: string,
    timeOffCreateBody?: TimeOffCreateBody,
 options?: SecondParameter<typeof customInstance<TimeOffResponse>>,) => {
      return customInstance<TimeOffResponse>(
      {url: `/api/orgs/${org}/employee/time-off`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timeOffCreateBody
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 * @summary Show a time off request for the authenticated employee in an org
 */
const getOrgsOrgEmployeeTimeOffTimeOff = (
    org: string,
    timeOff: string,
 options?: SecondParameter<typeof customInstance<TimeOffResponse>>,) => {
      return customInstance<TimeOffResponse>(
      {url: `/api/orgs/${org}/employee/time-off/${timeOff}`, method: 'GET'
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 * @summary Update a time off request for the authenticated employee in an org
 */
const patchOrgsOrgEmployeeTimeOffTimeOff = (
    org: string,
    timeOff: string,
    timeOffUpdateBody?: TimeOffUpdateBody,
 options?: SecondParameter<typeof customInstance<TimeOffResponse>>,) => {
      return customInstance<TimeOffResponse>(
      {url: `/api/orgs/${org}/employee/time-off/${timeOff}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: timeOffUpdateBody
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 *
 * > #### Sorting
 * > Currently this request is sorted by the dates and only the direction can be changed. By default it is sorted in ascending order.
 * @summary List date items of time off requests for the authenticated employee in an org
 */
const getOrgsOrgEmployeeTimeOffDates = (
    org: string,
    params?: GetOrgsOrgEmployeeTimeOffDatesParams,
 options?: SecondParameter<typeof customInstance<TimeOffDateListResponse>>,) => {
      return customInstance<TimeOffDateListResponse>(
      {url: `/api/orgs/${org}/employee/time-off/dates`, method: 'GET',
        params
    },
      options);
    }

/**
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.edit` (from `manager` role)
 * > If the authenticated user does not have this permission (or a role with this permission) for the organisation defined in the path you will receive a `403` error.
 * @summary List time off requests
 */
const getOrgsOrgTimeOff = (
    org: string,
    params?: GetOrgsOrgTimeOffParams,
 options?: SecondParameter<typeof customInstance<TimeOffListResponse>>,) => {
      return customInstance<TimeOffListResponse>(
      {url: `/api/orgs/${org}/time-off`, method: 'GET',
        params
    },
      options);
    }

/**
 * List time off dates for the org
 * @summary List time off request by dates
 */
const getOrgsOrgTimeOffDates = (
    org: string,
    params?: GetOrgsOrgTimeOffDatesParams,
 options?: SecondParameter<typeof customInstance<TimeOffDateListResponse>>,) => {
      return customInstance<TimeOffDateListResponse>(
      {url: `/api/orgs/${org}/time-off/dates`, method: 'GET',
        params
    },
      options);
    }

/**
 * CHG-10: the organisation's time off reasons (archived ones left out), ordered by name. Reasons are sensitive: managers only.
 *
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.edit` (from `manager` role)
 * > If the authenticated user does not have this permission (or a role with this permission) for the organisation defined in the path you will receive a `403` error.
 * @summary List time off reasons
 */
const getOrgsOrgTimeOffReasons = (
    org: string,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgTimeOffReasons200>>,) => {
      return customInstance<GetOrgsOrgTimeOffReasons200>(
      {url: `/api/orgs/${org}/time-off-reasons`, method: 'GET'
    },
      options);
    }

/**
 * Creates approved time off: one whole site-local day per date. `time_off_reason_id` is optional (CHG-10).
 *
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.edit` (from `manager` role)
 * > If the authenticated user does not have this permission (or a role with this permission) for the organisation defined in the path you will receive a `403` error.
 * @summary Create approved time off for an employee (manager)
 */
const postOrgsOrgCandidateLeaveRequests = (
    org: string,
    postOrgsOrgCandidateLeaveRequestsBody?: PostOrgsOrgCandidateLeaveRequestsBody,
 options?: SecondParameter<typeof customInstance<CandidateLeaveRequestResponse>>,) => {
      return customInstance<CandidateLeaveRequestResponse>(
      {url: `/api/orgs/${org}/candidate_leave_requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postOrgsOrgCandidateLeaveRequestsBody
    },
      options);
    }

/**
 * Only the keys sent are changed. `time_off_reason_id`: a reason sets or changes it, `null` clears it (CHG-10).
 *
 * <!-- theme: warning -->
 * > #### Feature Flag: `time_off`
 * > If this flag is not set for the organisation defined in the path you will receive a `403` error.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.edit` (from `manager` role)
 * > If the authenticated user does not have this permission (or a role with this permission) for the organisation defined in the path you will receive a `403` error.
 * @summary Respond to or edit time off (manager)
 */
const patchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequest = (
    org: string,
    candidateLeaveRequest: string,
    patchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequestBody?: PatchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequestBody,
 options?: SecondParameter<typeof customInstance<CandidateLeaveRequestResponse>>,) => {
      return customInstance<CandidateLeaveRequestResponse>(
      {url: `/api/orgs/${org}/candidate_leave_requests/${candidateLeaveRequest}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequestBody
    },
      options);
    }

/**
 * CHG-15: requests to join this organisation, made in the legacy apps with the organisation's code and a job role. Newest first.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.create` (from `manager` role)
 * > If the authenticated user does not have this permission for the organisation defined in the path you will receive a `403` error.
 * @summary List join requests
 */
const getOrgsOrgJoinRequests = (
    org: string,
    params?: GetOrgsOrgJoinRequestsParams,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgJoinRequests200>>,) => {
      return customInstance<GetOrgsOrgJoinRequests200>(
      {url: `/api/orgs/${org}/join-requests`, method: 'GET',
        params
    },
      options);
    }

/**
 * CHG-15: creates the employee from the user's profile (first name, last name, email, contact number) with the requested job role and the staff role only, and emails + pushes the user. A request that was already answered is a `409`; a person (or email) already in the organisation is a `422`; another organisation's request is a `404`.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.create` (from `manager` role)
 * > If the authenticated user does not have this permission for the organisation defined in the path you will receive a `403` error.
 * @summary Approve a join request
 */
const postOrgsOrgJoinRequestsJoinRequestApprove = (
    org: string,
    joinRequest: string,
 options?: SecondParameter<typeof customInstance<JoinRequestResponse>>,) => {
      return customInstance<JoinRequestResponse>(
      {url: `/api/orgs/${org}/join-requests/${joinRequest}/approve`, method: 'POST'
    },
      options);
    }

/**
 * CHG-15: marks the request declined and emails + pushes the user. Already answered → `409`; another organisation's request → `404`.
 *
 * <!-- theme: warning -->
 * > #### Permission: `employees.create` (from `manager` role)
 * > If the authenticated user does not have this permission for the organisation defined in the path you will receive a `403` error.
 * @summary Decline a join request
 */
const postOrgsOrgJoinRequestsJoinRequestDecline = (
    org: string,
    joinRequest: string,
 options?: SecondParameter<typeof customInstance<JoinRequestResponse>>,) => {
      return customInstance<JoinRequestResponse>(
      {url: `/api/orgs/${org}/join-requests/${joinRequest}/decline`, method: 'POST'
    },
      options);
    }

/**
 * Change password for the current user
 * @summary Change Password for the Authenticated User
 */
const putUserPassword = (
    putUserPasswordBody?: PutUserPasswordBody,
 options?: SecondParameter<typeof customInstance<string>>,) => {
      return customInstance<string>(
      {url: `/api/user/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserPasswordBody
    },
      options);
    }

/**
 * Change the push token for the current user
 * @summary LEGACY Update users push token
 */
const putUserPushToken = (
    putUserPushTokenBody?: PutUserPushTokenBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/user/push_token`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserPushTokenBody
    },
      options);
    }

/**
 * List push tokens for the current user
 * @summary List push tokens for the user
 */
const getUserPushTokens = (

 options?: SecondParameter<typeof customInstance<GetUserPushTokens200>>,) => {
      return customInstance<GetUserPushTokens200>(
      {url: `/api/user/push-tokens`, method: 'GET'
    },
      options);
    }

/**
 * Create or update a push token
 * @summary Create or update a push token
 */
const putUserPushTokens = (
    putUserPushTokensBody?: PutUserPushTokensBody,
 options?: SecondParameter<typeof customInstance<PutUserPushTokens201>>,) => {
      return customInstance<PutUserPushTokens201>(
      {url: `/api/user/push-tokens`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserPushTokensBody
    },
      options);
    }

/**
 * Remove a push token
 * @summary Delete a push token
 */
const deleteUserPushTokensPushToken = (
    pushToken: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/user/push-tokens/${pushToken}`, method: 'DELETE'
    },
      options);
    }

/**
 * List skills for an org
 * @summary List Skills for an Organisation
 */
const getOrgsOrgSkills = (
    org: string,
    params?: GetOrgsOrgSkillsParams,
 options?: SecondParameter<typeof customInstance<SkillListResponse>>,) => {
      return customInstance<SkillListResponse>(
      {url: `/api/orgs/${org}/skills`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary List Shift Booking Constraint Profiles for an Org
 */
const getOrgsOrgShiftBookingConstraintProfiles = (
    org: string,
    params?: GetOrgsOrgShiftBookingConstraintProfilesParams,
 options?: SecondParameter<typeof customInstance<ShiftBookingConstraintProfileListResponse>>,) => {
      return customInstance<ShiftBookingConstraintProfileListResponse>(
      {url: `/api/orgs/${org}/shift-booking-constraint-profiles`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Get a Shift Booking Constraint Profile
 */
const getOrgsOrgShiftBookingConstraintProfilesProfile = (
    org: string,
    profile: string,
 options?: SecondParameter<typeof customInstance<ShiftBookingConstraintProfileResponse>>,) => {
      return customInstance<ShiftBookingConstraintProfileResponse>(
      {url: `/api/orgs/${org}/shift-booking-constraint-profiles/${profile}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Update Shift Booking Constraint Profile
 */
const patchOrgsOrgShiftBookingConstraintProfilesProfile = (
    org: string,
    profile: string,
    shiftBookingConstraintProfileUpdateBody?: ShiftBookingConstraintProfileUpdateBody,
 options?: SecondParameter<typeof customInstance<ShiftBookingConstraintProfileResponse>>,) => {
      return customInstance<ShiftBookingConstraintProfileResponse>(
      {url: `/api/orgs/${org}/shift-booking-constraint-profiles/${profile}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: shiftBookingConstraintProfileUpdateBody
    },
      options);
    }

/**
 * @summary Get an employees Shift Booking Constraint Profile
 */
const getOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile = (
    org: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<ShiftBookingConstraintProfileEmployeeResponse>>,) => {
      return customInstance<ShiftBookingConstraintProfileEmployeeResponse>(
      {url: `/api/orgs/${org}/employees/${employee}/shift-booking-constraint-profile`, method: 'GET'
    },
      options);
    }

/**
 * @summary Set an employees Shift Booking Constraint Profile
 */
const putOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile = (
    org: string,
    employee: string,
    putOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileBody?: PutOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/employees/${employee}/shift-booking-constraint-profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileBody
    },
      options);
    }

/**
 * @summary Unset an employees shift booking contraint profile
 */
const deleteOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile = (
    org: string,
    employee: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/orgs/${org}/employees/${employee}/shift-booking-constraint-profile`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Create a timesheet
 */
const postOrgsOrgTimesheets = (
    org: string,
    timesheetCreateBody?: TimesheetCreateBody,
 options?: SecondParameter<typeof customInstance<TimesheetResponse>>,) => {
      return customInstance<TimesheetResponse>(
      {url: `/api/orgs/${org}/timesheets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timesheetCreateBody
    },
      options);
    }

/**
 * @summary Create an event for a timesheet
 */
const postOrgsOrgTimesheetsTimesheetEvents = (
    org: string,
    timesheet: string,
    timesheetEventCreateBody?: TimesheetEventCreateBody,
 options?: SecondParameter<typeof customInstance<TimesheetEventResponse>>,) => {
      return customInstance<TimesheetEventResponse>(
      {url: `/api/orgs/${org}/timesheets/${timesheet}/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timesheetEventCreateBody
    },
      options);
    }

/**
 * @summary View a timesheet
 */
const getOrgsOrgTimesheetsTimesheet = (
    org: string,
    timesheet: string,
 options?: SecondParameter<typeof customInstance<TimesheetResponse>>,) => {
      return customInstance<TimesheetResponse>(
      {url: `/api/orgs/${org}/timesheets/${timesheet}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Enable Two Factor Authentication
 */
const postUserTwoFactorAuthentication = (

 options?: SecondParameter<typeof customInstance<string>>,) => {
      return customInstance<string>(
      {url: `/api/user/two-factor-authentication`, method: 'POST'
    },
      options);
    }

/**
 * @summary Disable Two Factor Authentication
 */
const deleteUserTwoFactorAuthentication = (

 options?: SecondParameter<typeof customInstance<string>>,) => {
      return customInstance<string>(
      {url: `/api/user/two-factor-authentication`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary List Two Factor Recovery Codes
 */
const getUserTwoFactorRecoveryCodes = (

 options?: SecondParameter<typeof customInstance<string[]>>,) => {
      return customInstance<string[]>(
      {url: `/api/user/two-factor-recovery-codes`, method: 'GET'
    },
      options);
    }

/**
 * @summary Regenerate Two Factor Recovery Codes
 */
const postUserTwoFactorRecoveryCodes = (

 options?: SecondParameter<typeof customInstance<string>>,) => {
      return customInstance<string>(
      {url: `/api/user/two-factor-recovery-codes`, method: 'POST'
    },
      options);
    }

/**
 * @summary Confirm Two Factor Code
 */
const postUserConfirmedTwoFactorAuthentication = (
    postUserConfirmedTwoFactorAuthenticationBody?: PostUserConfirmedTwoFactorAuthenticationBody,
 options?: SecondParameter<typeof customInstance<string>>,) => {
      return customInstance<string>(
      {url: `/api/user/confirmed-two-factor-authentication`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserConfirmedTwoFactorAuthenticationBody
    },
      options);
    }

/**
 * @summary Show Two Factor Secret Key
 */
const getUserTwoFactorSecretKey = (

 options?: SecondParameter<typeof customInstance<GetUserTwoFactorSecretKey200>>,) => {
      return customInstance<GetUserTwoFactorSecretKey200>(
      {url: `/api/user/two-factor-secret-key`, method: 'GET'
    },
      options);
    }

/**
 * @summary Show Two Factor QR Code
 */
const getUserTwoFactorQrCode = (

 options?: SecondParameter<typeof customInstance<GetUserTwoFactorQrCode200>>,) => {
      return customInstance<GetUserTwoFactorQrCode200>(
      {url: `/api/user/two-factor-qr-code`, method: 'GET'
    },
      options);
    }

/**
 * @summary Get org subscription
 */
const getOrgsOrgBillingSubscription = (
    org: string,
 options?: SecondParameter<typeof customInstance<SubscriptionResponse>>,) => {
      return customInstance<SubscriptionResponse>(
      {url: `/api/orgs/${org}/billing/subscription`, method: 'GET'
    },
      options);
    }

/**
 * @summary List plans
 */
const getBillingCatalogue = (

 options?: SecondParameter<typeof customInstance<PlanListResponse>>,) => {
      return customInstance<PlanListResponse>(
      {url: `/api/billing/catalogue`, method: 'GET'
    },
      options);
    }

/**
 * @summary Get Onboarding Draft
 */
const getOrgsOrgOnboardingDraft = (
    org: string,
 options?: SecondParameter<typeof customInstance<OnboardingDraft>>,) => {
      return customInstance<OnboardingDraft>(
      {url: `/api/orgs/${org}/onboarding/draft`, method: 'GET'
    },
      options);
    }

/**
 * @summary Save Onboarding Draft
 */
const putOrgsOrgOnboardingDraft = (
    org: string,
    onboardingDraftSaveBody?: OnboardingDraftSaveBody,
 options?: SecondParameter<typeof customInstance<PutOrgsOrgOnboardingDraft200>>,) => {
      return customInstance<PutOrgsOrgOnboardingDraft200>(
      {url: `/api/orgs/${org}/onboarding/draft`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingDraftSaveBody
    },
      options);
    }

/**
 * @summary Your GET endpoint
 */
const getOrgsOrgOnboardingComplete = (
    org: string,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgOnboardingComplete200>>,) => {
      return customInstance<GetOrgsOrgOnboardingComplete200>(
      {url: `/api/orgs/${org}/onboarding/complete`, method: 'GET'
    },
      options);
    }

/**
 * @summary Get user permissions for org
 */
const getOrgsOrgUserPermissions = (
    org: string,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgUserPermissions200>>,) => {
      return customInstance<GetOrgsOrgUserPermissions200>(
      {url: `/api/orgs/${org}/user/permissions`, method: 'GET'
    },
      options);
    }

/**
 * @summary Get org config
 */
const getOrgsOrgConfig = (
    org: string,
 options?: SecondParameter<typeof customInstance<GetOrgsOrgConfig200>>,) => {
      return customInstance<GetOrgsOrgConfig200>(
      {url: `/api/orgs/${org}/config`, method: 'GET'
    },
      options);
    }

return {getSitesSiteIdUsers,postSitesSiteUsers,getSitesSiteUsersUser,patchSitesSiteUsersUser,postSitesSiteUsersUserMembership,deleteSitesSiteUsersUserMembership,getOrgsOrgGroups,postOrgsOrgGroups,getOrgsOrgGroupsGroup,patchOrgsOrgGroupsGroup,deleteOrgsOrgGroupsGroup,getSitesSiteGroupsGroupUsers,postSitesSiteGroupsGroupUsers,deleteSitesSiteGroupsGroupUsers,getSitesSiteEmployees,getSitesSiteEmployeesEmployee,getSitesSiteDepartments,postSitesSiteDepartments,getSitesSiteDepartmentsDepartment,patchSitesSiteDepartmentsDepartment,deleteSitesSiteDepartmentsDepartment,getSitesSiteDepartmentsDepartmentMembers,postSitesSiteDepartmentsDepartmentMembers,deleteSitesSiteDepartmentsDepartmentMembers,getOrgsOrgInsightsAcceptance,getOrgsOrgInsightsEngagementChange,getOrgsOrgShiftsReasons,postOrgsOrgShiftsReasons,getOrgsOrgShiftsReasonsReason,patchOrgsOrgShiftsReasonsReason,getOrgsOrgJobTitles,postOrgsOrgJobTitles,getOrgsOrgJobTitlesJobTitle,patchOrgsOrgJobTitlesJobTitle,putOrgsOrgJobTitlesJobTitleArchive,deleteOrgsOrgJobTitlesJobTitleArchive,getOrgsOrgJobTitlesJobTitleJobRoles,putOrgsOrgJobTitlesJobTitleJobRoles,getOrgsOrgJobRoles,postOrgsOrgJobRoles,getOrgsOrgJobRolesJobRole,patchOrgsOrgJobRolesJobRole,putOrgsOrgJobRolesJobRoleArchive,deleteOrgsOrgJobRolesJobRoleArchive,getOrgsOrgEmployees,postOrgsOrgEmployees,getOrgsOrgEmployeesEmployeeEffectiveJobRoles,putOrgsOrgEmployeesEmployeeJobRoleGrantsJobRole,deleteOrgsOrgEmployeesEmployeeJobRoleGrantsJobRole,getOrgs,getOrgsOrg,getOrgsOrgBuildings,postOrgsOrgBuildings,getOrgsOrgBuildingsBuilding,patchOrgsOrgBuildingsBuilding,deleteOrgsOrgBuildingsBuilding,putOrgsOrgBuildingsBuildingArchive,deleteOrgsOrgBuildingsBuildingArchive,getSitesSiteBuildingsBuildingAreas,postSitesSiteBuildingsBuildingAreas,getOrgsOrgAreas,postOrgsOrgAreas,getOrgsOrgAreasArea,patchOrgsOrgAreasArea,deleteOrgsOrgAreasArea,putOrgsOrgAreasAreaLock,deleteOrgsOrgAreasAreaLock,getOrgsOrgShifts,postOrgsOrgShifts,getOrgsOrgShiftsActivityExport,getOrgsOrgShiftsShiftEmployees,postOrgsOrgShiftsShiftEmployees,getAuthLogin,getAuthRegister,postAuthForgotPasswordCode,postAuthResetPasswordCode,postVonageMessagesInbound,postVonageMessagesStatus,getOrgsOrgEmployeesEmployeeSkills,postOrgsOrgEmployeesEmployeeSkills,deleteOrgsOrgEmployeesEmployeeSkills,putOrgsOrgBuildingsBuildingMembershipsEmployee,deleteOrgsOrgBuildingsBuildingMembershipsEmployee,getOrgsOrgEmployeesEmployeeBuildings,getOrgsOrgEmployeesEmployeeAreas,putOrgsOrgAreasAreaMembershipsEmployee,deleteOrgsOrgAreasAreaMembershipsEmployee,getOrgsOrgNotifications,putOrgsOrgNotifications,putOrgsOrgNotificationsNotification,getOrgsOrgEmployeeShifts,getOrgsOrgEmployeeShiftsShift,postOrgsOrgUserShiftsShift,putOrgsOrgEmployeeShiftsShiftOffer,deleteOrgsOrgEmployeeShiftsShiftOffer,deleteOrgsOrgEmployeeShiftsShiftOfferWithdraw,getOrgsOrgEmployeeBuildingsMemberships,getOrgsOrgEmployeePermissions,getOrgsOrgEmployeeSkills,getOrgsOrgEmployeeBuildings,getOrgsOrgEmployeeShiftsRoster,getUser,getOrgsOrgEmployee,getAvailability,postAvailabilityBulk,deleteAvailabilityAvailability,getOrgsOrgEmployeeBroadcasts,putOrgsOrgEmployeeBroadcasts,patchOrgsOrgEmployeeBroadcastsBroadcast,putOrgsOrgSkillsSkillEmployeesEmployee,deleteOrgsOrgSkillsSkillEmployeesEmployee,getOrgsOrgEmployeeTimeOff,postOrgsOrgEmployeeTimeOff,getOrgsOrgEmployeeTimeOffTimeOff,patchOrgsOrgEmployeeTimeOffTimeOff,getOrgsOrgEmployeeTimeOffDates,getOrgsOrgTimeOff,getOrgsOrgTimeOffDates,getOrgsOrgTimeOffReasons,postOrgsOrgCandidateLeaveRequests,patchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequest,getOrgsOrgJoinRequests,postOrgsOrgJoinRequestsJoinRequestApprove,postOrgsOrgJoinRequestsJoinRequestDecline,putUserPassword,putUserPushToken,getUserPushTokens,putUserPushTokens,deleteUserPushTokensPushToken,getOrgsOrgSkills,getOrgsOrgShiftBookingConstraintProfiles,getOrgsOrgShiftBookingConstraintProfilesProfile,patchOrgsOrgShiftBookingConstraintProfilesProfile,getOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile,putOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile,deleteOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile,postOrgsOrgTimesheets,postOrgsOrgTimesheetsTimesheetEvents,getOrgsOrgTimesheetsTimesheet,postUserTwoFactorAuthentication,deleteUserTwoFactorAuthentication,getUserTwoFactorRecoveryCodes,postUserTwoFactorRecoveryCodes,postUserConfirmedTwoFactorAuthentication,getUserTwoFactorSecretKey,getUserTwoFactorQrCode,getOrgsOrgBillingSubscription,getBillingCatalogue,getOrgsOrgOnboardingDraft,putOrgsOrgOnboardingDraft,getOrgsOrgOnboardingComplete,getOrgsOrgUserPermissions,getOrgsOrgConfig}};
export type GetSitesSiteIdUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteIdUsers']>>>
export type PostSitesSiteUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postSitesSiteUsers']>>>
export type GetSitesSiteUsersUserResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteUsersUser']>>>
export type PatchSitesSiteUsersUserResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchSitesSiteUsersUser']>>>
export type PostSitesSiteUsersUserMembershipResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postSitesSiteUsersUserMembership']>>>
export type DeleteSitesSiteUsersUserMembershipResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteSitesSiteUsersUserMembership']>>>
export type GetOrgsOrgGroupsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgGroups']>>>
export type PostOrgsOrgGroupsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgGroups']>>>
export type GetOrgsOrgGroupsGroupResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgGroupsGroup']>>>
export type PatchOrgsOrgGroupsGroupResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgGroupsGroup']>>>
export type DeleteOrgsOrgGroupsGroupResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgGroupsGroup']>>>
export type GetSitesSiteGroupsGroupUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteGroupsGroupUsers']>>>
export type PostSitesSiteGroupsGroupUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postSitesSiteGroupsGroupUsers']>>>
export type DeleteSitesSiteGroupsGroupUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteSitesSiteGroupsGroupUsers']>>>
export type GetSitesSiteEmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteEmployees']>>>
export type GetSitesSiteEmployeesEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteEmployeesEmployee']>>>
export type GetSitesSiteDepartmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteDepartments']>>>
export type PostSitesSiteDepartmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postSitesSiteDepartments']>>>
export type GetSitesSiteDepartmentsDepartmentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteDepartmentsDepartment']>>>
export type PatchSitesSiteDepartmentsDepartmentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchSitesSiteDepartmentsDepartment']>>>
export type DeleteSitesSiteDepartmentsDepartmentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteSitesSiteDepartmentsDepartment']>>>
export type GetSitesSiteDepartmentsDepartmentMembersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteDepartmentsDepartmentMembers']>>>
export type PostSitesSiteDepartmentsDepartmentMembersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postSitesSiteDepartmentsDepartmentMembers']>>>
export type DeleteSitesSiteDepartmentsDepartmentMembersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteSitesSiteDepartmentsDepartmentMembers']>>>
export type GetOrgsOrgInsightsAcceptanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgInsightsAcceptance']>>>
export type GetOrgsOrgInsightsEngagementChangeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgInsightsEngagementChange']>>>
export type GetOrgsOrgShiftsReasonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShiftsReasons']>>>
export type PostOrgsOrgShiftsReasonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgShiftsReasons']>>>
export type GetOrgsOrgShiftsReasonsReasonResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShiftsReasonsReason']>>>
export type PatchOrgsOrgShiftsReasonsReasonResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgShiftsReasonsReason']>>>
export type GetOrgsOrgJobTitlesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgJobTitles']>>>
export type PostOrgsOrgJobTitlesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgJobTitles']>>>
export type GetOrgsOrgJobTitlesJobTitleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgJobTitlesJobTitle']>>>
export type PatchOrgsOrgJobTitlesJobTitleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgJobTitlesJobTitle']>>>
export type PutOrgsOrgJobTitlesJobTitleArchiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgJobTitlesJobTitleArchive']>>>
export type DeleteOrgsOrgJobTitlesJobTitleArchiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgJobTitlesJobTitleArchive']>>>
export type GetOrgsOrgJobTitlesJobTitleJobRolesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgJobTitlesJobTitleJobRoles']>>>
export type PutOrgsOrgJobTitlesJobTitleJobRolesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgJobTitlesJobTitleJobRoles']>>>
export type GetOrgsOrgJobRolesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgJobRoles']>>>
export type PostOrgsOrgJobRolesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgJobRoles']>>>
export type GetOrgsOrgJobRolesJobRoleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgJobRolesJobRole']>>>
export type PatchOrgsOrgJobRolesJobRoleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgJobRolesJobRole']>>>
export type PutOrgsOrgJobRolesJobRoleArchiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgJobRolesJobRoleArchive']>>>
export type DeleteOrgsOrgJobRolesJobRoleArchiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgJobRolesJobRoleArchive']>>>
export type GetOrgsOrgEmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployees']>>>
export type PostOrgsOrgEmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgEmployees']>>>
export type GetOrgsOrgEmployeesEmployeeEffectiveJobRolesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeesEmployeeEffectiveJobRoles']>>>
export type PutOrgsOrgEmployeesEmployeeJobRoleGrantsJobRoleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgEmployeesEmployeeJobRoleGrantsJobRole']>>>
export type DeleteOrgsOrgEmployeesEmployeeJobRoleGrantsJobRoleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgEmployeesEmployeeJobRoleGrantsJobRole']>>>
export type GetOrgsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgs']>>>
export type GetOrgsOrgResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrg']>>>
export type GetOrgsOrgBuildingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgBuildings']>>>
export type PostOrgsOrgBuildingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgBuildings']>>>
export type GetOrgsOrgBuildingsBuildingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgBuildingsBuilding']>>>
export type PatchOrgsOrgBuildingsBuildingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgBuildingsBuilding']>>>
export type DeleteOrgsOrgBuildingsBuildingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgBuildingsBuilding']>>>
export type PutOrgsOrgBuildingsBuildingArchiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgBuildingsBuildingArchive']>>>
export type DeleteOrgsOrgBuildingsBuildingArchiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgBuildingsBuildingArchive']>>>
export type GetSitesSiteBuildingsBuildingAreasResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getSitesSiteBuildingsBuildingAreas']>>>
export type PostSitesSiteBuildingsBuildingAreasResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postSitesSiteBuildingsBuildingAreas']>>>
export type GetOrgsOrgAreasResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgAreas']>>>
export type PostOrgsOrgAreasResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgAreas']>>>
export type GetOrgsOrgAreasAreaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgAreasArea']>>>
export type PatchOrgsOrgAreasAreaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgAreasArea']>>>
export type DeleteOrgsOrgAreasAreaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgAreasArea']>>>
export type PutOrgsOrgAreasAreaLockResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgAreasAreaLock']>>>
export type DeleteOrgsOrgAreasAreaLockResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgAreasAreaLock']>>>
export type GetOrgsOrgShiftsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShifts']>>>
export type PostOrgsOrgShiftsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgShifts']>>>
export type GetOrgsOrgShiftsActivityExportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShiftsActivityExport']>>>
export type GetOrgsOrgShiftsShiftEmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShiftsShiftEmployees']>>>
export type PostOrgsOrgShiftsShiftEmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgShiftsShiftEmployees']>>>
export type GetAuthLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getAuthLogin']>>>
export type GetAuthRegisterResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getAuthRegister']>>>
export type PostAuthForgotPasswordCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postAuthForgotPasswordCode']>>>
export type PostAuthResetPasswordCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postAuthResetPasswordCode']>>>
export type PostVonageMessagesInboundResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postVonageMessagesInbound']>>>
export type PostVonageMessagesStatusResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postVonageMessagesStatus']>>>
export type GetOrgsOrgEmployeesEmployeeSkillsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeesEmployeeSkills']>>>
export type PostOrgsOrgEmployeesEmployeeSkillsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgEmployeesEmployeeSkills']>>>
export type DeleteOrgsOrgEmployeesEmployeeSkillsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgEmployeesEmployeeSkills']>>>
export type PutOrgsOrgBuildingsBuildingMembershipsEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgBuildingsBuildingMembershipsEmployee']>>>
export type DeleteOrgsOrgBuildingsBuildingMembershipsEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgBuildingsBuildingMembershipsEmployee']>>>
export type GetOrgsOrgEmployeesEmployeeBuildingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeesEmployeeBuildings']>>>
export type GetOrgsOrgEmployeesEmployeeAreasResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeesEmployeeAreas']>>>
export type PutOrgsOrgAreasAreaMembershipsEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgAreasAreaMembershipsEmployee']>>>
export type DeleteOrgsOrgAreasAreaMembershipsEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgAreasAreaMembershipsEmployee']>>>
export type GetOrgsOrgNotificationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgNotifications']>>>
export type PutOrgsOrgNotificationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgNotifications']>>>
export type PutOrgsOrgNotificationsNotificationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgNotificationsNotification']>>>
export type GetOrgsOrgEmployeeShiftsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeShifts']>>>
export type GetOrgsOrgEmployeeShiftsShiftResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeShiftsShift']>>>
export type PostOrgsOrgUserShiftsShiftResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgUserShiftsShift']>>>
export type PutOrgsOrgEmployeeShiftsShiftOfferResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgEmployeeShiftsShiftOffer']>>>
export type DeleteOrgsOrgEmployeeShiftsShiftOfferResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgEmployeeShiftsShiftOffer']>>>
export type DeleteOrgsOrgEmployeeShiftsShiftOfferWithdrawResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgEmployeeShiftsShiftOfferWithdraw']>>>
export type GetOrgsOrgEmployeeBuildingsMembershipsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeBuildingsMemberships']>>>
export type GetOrgsOrgEmployeePermissionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeePermissions']>>>
export type GetOrgsOrgEmployeeSkillsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeSkills']>>>
export type GetOrgsOrgEmployeeBuildingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeBuildings']>>>
export type GetOrgsOrgEmployeeShiftsRosterResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeShiftsRoster']>>>
export type GetUserResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getUser']>>>
export type GetOrgsOrgEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployee']>>>
export type GetAvailabilityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getAvailability']>>>
export type PostAvailabilityBulkResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postAvailabilityBulk']>>>
export type DeleteAvailabilityAvailabilityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteAvailabilityAvailability']>>>
export type GetOrgsOrgEmployeeBroadcastsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeBroadcasts']>>>
export type PutOrgsOrgEmployeeBroadcastsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgEmployeeBroadcasts']>>>
export type PatchOrgsOrgEmployeeBroadcastsBroadcastResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgEmployeeBroadcastsBroadcast']>>>
export type PutOrgsOrgSkillsSkillEmployeesEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgSkillsSkillEmployeesEmployee']>>>
export type DeleteOrgsOrgSkillsSkillEmployeesEmployeeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgSkillsSkillEmployeesEmployee']>>>
export type GetOrgsOrgEmployeeTimeOffResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeTimeOff']>>>
export type PostOrgsOrgEmployeeTimeOffResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgEmployeeTimeOff']>>>
export type GetOrgsOrgEmployeeTimeOffTimeOffResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeTimeOffTimeOff']>>>
export type PatchOrgsOrgEmployeeTimeOffTimeOffResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgEmployeeTimeOffTimeOff']>>>
export type GetOrgsOrgEmployeeTimeOffDatesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeeTimeOffDates']>>>
export type GetOrgsOrgTimeOffResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgTimeOff']>>>
export type GetOrgsOrgTimeOffDatesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgTimeOffDates']>>>
export type GetOrgsOrgTimeOffReasonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgTimeOffReasons']>>>
export type PostOrgsOrgCandidateLeaveRequestsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgCandidateLeaveRequests']>>>
export type PatchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequestResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgCandidateLeaveRequestsCandidateLeaveRequest']>>>
export type GetOrgsOrgJoinRequestsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgJoinRequests']>>>
export type PostOrgsOrgJoinRequestsJoinRequestApproveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgJoinRequestsJoinRequestApprove']>>>
export type PostOrgsOrgJoinRequestsJoinRequestDeclineResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgJoinRequestsJoinRequestDecline']>>>
export type PutUserPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putUserPassword']>>>
export type PutUserPushTokenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putUserPushToken']>>>
export type GetUserPushTokensResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getUserPushTokens']>>>
export type PutUserPushTokensResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putUserPushTokens']>>>
export type DeleteUserPushTokensPushTokenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteUserPushTokensPushToken']>>>
export type GetOrgsOrgSkillsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgSkills']>>>
export type GetOrgsOrgShiftBookingConstraintProfilesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShiftBookingConstraintProfiles']>>>
export type GetOrgsOrgShiftBookingConstraintProfilesProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgShiftBookingConstraintProfilesProfile']>>>
export type PatchOrgsOrgShiftBookingConstraintProfilesProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['patchOrgsOrgShiftBookingConstraintProfilesProfile']>>>
export type GetOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile']>>>
export type PutOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile']>>>
export type DeleteOrgsOrgEmployeesEmployeeShiftBookingConstraintProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteOrgsOrgEmployeesEmployeeShiftBookingConstraintProfile']>>>
export type PostOrgsOrgTimesheetsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgTimesheets']>>>
export type PostOrgsOrgTimesheetsTimesheetEventsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postOrgsOrgTimesheetsTimesheetEvents']>>>
export type GetOrgsOrgTimesheetsTimesheetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgTimesheetsTimesheet']>>>
export type PostUserTwoFactorAuthenticationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postUserTwoFactorAuthentication']>>>
export type DeleteUserTwoFactorAuthenticationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['deleteUserTwoFactorAuthentication']>>>
export type GetUserTwoFactorRecoveryCodesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getUserTwoFactorRecoveryCodes']>>>
export type PostUserTwoFactorRecoveryCodesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postUserTwoFactorRecoveryCodes']>>>
export type PostUserConfirmedTwoFactorAuthenticationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['postUserConfirmedTwoFactorAuthentication']>>>
export type GetUserTwoFactorSecretKeyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getUserTwoFactorSecretKey']>>>
export type GetUserTwoFactorQrCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getUserTwoFactorQrCode']>>>
export type GetOrgsOrgBillingSubscriptionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgBillingSubscription']>>>
export type GetBillingCatalogueResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getBillingCatalogue']>>>
export type GetOrgsOrgOnboardingDraftResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgOnboardingDraft']>>>
export type PutOrgsOrgOnboardingDraftResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['putOrgsOrgOnboardingDraft']>>>
export type GetOrgsOrgOnboardingCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgOnboardingComplete']>>>
export type GetOrgsOrgUserPermissionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgUserPermissions']>>>
export type GetOrgsOrgConfigResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCliniShiftManager>['getOrgsOrgConfig']>>>
